import React, { useEffect, useState } from "react";
import { Text, View, Switch, StyleSheet, FlatList, TouchableOpacity, useWindowDimensions } from "react-native";

import OrderElement from "../components/OrderElement";
import useWooOrders from "../hooks/useWooOrders";

import Config from "../config/Config";

const config = new Config();

const WAIT_MESSAGE = 'Aguarde...';
const READY_MESSAGE = 'Pronto';

const OrdersScreen = ({ route, navigation }) => {
  const { width, height } = useWindowDimensions();
  const [refreshing, setRefreshing] = useState(false);
  const [orders, setOrders, loadOrders] = useWooOrders(setRefreshing);
  const [onHold, setOnHold] = useState(true);
  const [cancelled, setCancelled] = useState(false);
  const [completed, setCompleted] = useState(false);

  const { order, response } = route.params;

  const [myTimer, setMyTimer] = useState();

  const showOrderDetails = (item) => {
    navigation.navigate("OrderDetails", { selectedOrder: item, navigationAction: 'OPEN_ORDER' });
  }

  const onRefresh = () => {
console.log("onRefresh called");
    syncCall(loadOrders);
  }

  const syncCall = async (asyncFunction, ...args) => {
    setRefreshing(true);
    await asyncFunction(...args);
    setRefreshing(false);
  }
  
  useEffect(()=>{ 
    if (order) {
      syncCall(updateOrder, order, response);
    } else {
      syncCall(loadOrders);
    }
    // setMyTimer(setInterval(onRefresh, 30000));
    // return clearInterval(myTimer);
    return;
  }, []);

  const showOrder = (status) => {
    switch(status) {
    case 'on-hold':
    case 'processing':
        return onHold;
    case 'cancelled':
        return cancelled;
    case 'completed':
        return completed;
    default:
        return true;
    }
  }

  const updateOrder = (updatedOrder) => {
    /*
    const data = JSON.parse(response.config.data);

    if (data.action === 'bill') {
      return;
    }

    if (response.status === 200) {
    */
      const updatedOrders = orders.map(currentOrder => {
        if (updatedOrder.id === currentOrder.id ) {
          /*
          let newOrder = updatedOrder;
          newOrder.status = data.status;
          if (['update', 'close'].includes(data.action)) {
            newOrder.items = data.line_items.map(item => {
              return {
                id: item.variation_id && item.variation_id > 0 ? item.variation_id : item.product_id,
                sku: item.sku,
                name: item.name,
                price: item.price,
                quantity: item.quantity,
              }
            });
            newOrder.fees = data.fee_lines;
            newOrder.shippings = data.shipping_lines;
            if (data.action === 'close') {
              newOrder.paymentMethodId = data.payment_method;
              newOrder.paymentMethodName = data.payment_method_title;
            }
          }
          newOrder.total = newOrder.items.reduce((acum, item) => acum + item.quantity * item.price, 0);
          return newOrder;
        */
          return updatedOrder;
        } else {
          return currentOrder;
        }
      });
      setOrders(updatedOrders);
    // }
  }

  return (
    <View>
      <View style={styles.controls}>
        {width > config.WIDTH_TRESHOLD && 
        <TouchableOpacity style={styles.ordersTitle} onPress={onRefresh}>
          <Text style={styles.ordersTitle}>Pedidos</Text>
        </TouchableOpacity>
        }
        <View style={width > config.WIDTH_TRESHOLD ? styles.controlsLandscape : styles.controlsPortrait}>
          <View style={styles.switch}>
            <Switch
              trackColor = {{ false: config.DISABLED_COLOR, true: config.ON_HOLD_COLOR }}
              thumbColor = {onHold ? config.ON_HOLD_COLOR : '#F4F4F4'}
              ios_backgroundColor = "#3e3e3e"
              onValueChange = {() => setOnHold(!onHold)}
              value = {onHold}
            />
            <Text style={styles.switchText}>Aguardando/Pendentes</Text>
          </View>
          <View style={styles.switch}>
            <Switch
              trackColor = {{ false: config.DISABLED_COLOR, true: config.COMPLETED_COLOR }}
              thumbColor = {completed ? config.COMPLETED_COLOR : '#F4F4F4'}
              ios_backgroundColor = "#3e3e3e"
              onValueChange = {() => setCompleted(!completed)}
              value = {completed}
            />
            <Text style={styles.switchText}>Concluídos</Text>
          </View>
          <View style={styles.switch}>
            <Switch
              trackColor = {{ false: config.DISABLED_COLOR, true: config.CANCELLED_COLOR }}
              thumbColor = {cancelled ? config.CANCELLED_COLOR : '#F4F4F4'}
              ios_backgroundColor = "#3e3e3e"
              onValueChange = {() => setCancelled(!cancelled)}
              value = {cancelled}
            />
            <Text style={styles.switchText}>Cancelados</Text>
          </View>
        </View>
        <Text style={[styles.statusMessage, {color: refreshing ? 'red' : 'green', borderColor: refreshing ? 'red' : 'green'}]}>
          {refreshing ? WAIT_MESSAGE : READY_MESSAGE}
        </Text>
      </View>
      <View style={styles.listStyle}>
        <FlatList
          LisHeaderComponent={<Text></Text>}
          ListFooterComponent={<Text></Text>}
          refreshing={refreshing}
          onRefresh={onRefresh}
          contentContainerStyle={styles.contentContainer}
          data={orders}
          keyExtractor={order => order.id.toString()}
          renderItem={({ item }) => {
            // Only return order if toggle for the particular order status is enabled
            return showOrder(item.status) && (
              <View style={styles.listStyle}>
                <TouchableOpacity onPress={() => showOrderDetails(item)}>
                  <OrderElement item={item}/>
                </TouchableOpacity>
              </View>
            );
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    paddingBottom: 80,
  },
  controls: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: 10,
    marginVertical: 5
  },
  controlsPortrait: {
    flexDirection: 'column', 
    alignItems: 'flex-start'
  },
  controlsLandscape: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flex: 1
  },
  listStyle: {
    marginHorizontal: 5,
    marginBottom: 5
  },
  ordersTitle: {
    fontSize: 30,
    fontWeight: 'bold',
    justifyContent: 'center',
    width: 120
  },
  switch: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  switchText: {
    fontSize: 17,
    fontWeight: 'bold',
    marginLeft: 5
  },
  statusMessage: {
    fontSize: 14,
    marginRight: 5,
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 10,
    paddingVertical: 3,
    textAlign: 'center',
    alignSelf: 'center',
    width: 90
  }
});

export default OrdersScreen;

